export const team = [
  {
    name: 'David Schwartz',
    role: 'Founder',
    image: '/img/team/schwartz.jpg',
    description:
      'David is a capital markets and technology executive with 15 years experience leading startups from inception through acquisition. He leads the sales and capital markets teams at WelcomeLend while consistently closing 9 figures in commercial real estate transactions.',
  },
  {
    name: 'Dave Gamache',
    role: 'Founder',
    image: '/img/team/gamache.jpg',
    description:
      'Dave is a designer and engineer with over a decade working with startups like Twitter, Netflix, Medium and Dropbox. He runs Product and Design at WelcomeLend, as well as being part owner of Bootstrap, one of the most popular open source projects in the world.',
  },
  {
    name: 'Yevgeny Simzikov',
    role: 'React/Product Engineer',
    image: '/img/team/simzikov.jpg',
    description:
      'Yevgeny is WelcomeLend’s front end architect for design systems and React. He’s an original member of the team and has scaled an early alpha release to a stable product used daily. He’s also a core team member of the Bootstrap Theme’s team, focusing on code quality and growth.',
  },
  {
    name: 'Sean Borger',
    role: 'Senior VP Capital Markets',
    image: '/img/team/sean.jpg',
    description:
      "Sean is a capital markets specialist with over 10+ years of experience in development, acquisitions, brokerage and financing. He's managed over $220M in development projects providing for a genuine understanding of his client’s capital needs and priorities.",
  },
  {
    name: 'John Young',
    role: 'Senior VP Capital Markets',
    image: '/img/team/john.jpg',
    description:
      'John has 10+ years of experience across the industry including private equity, architecture & development, and most recently capital markets at Walker & Dunlop with over $600m in financings. He holds both a BBA in Real Estate and Master of Architecture.',
  },
  {
    name: 'Rick White',
    role: 'Associate VP Capital Markets',
    image: '/img/team/white.jpg',
    description:
      'Rick started his career in investment banking working on mergers and acquisitions, private placements, and syndicated financings before focusing on CRE experience at CBRE. He holds both a BA from USC and a Master in Management and Finance from Duke.',
  },
  {
    name: 'Mark Gallinaro',
    role: 'Senior VP Structured Finance',
    image: '/img/team/gallinaro.jpg',
    description:
      'Mark is an institutionally-trained executive with 13+ years of experience. He worked at one of the largest real estate investment managers, and has been involved over $1B of transactions. Mark received his MBA from UCLA Anderson and BBA from the University of San Diego.',
  },
  {
    name: 'Garrett Newman',
    role: 'Associate VP Capital Markets',
    image: '/img/team/newman.jpg',
    description:
      'Garrett has several years of in depth CRE financial modeling, underwriting, and direct deal execution experience. He has worked at top banks across Texas as a commercial real estate lender placing over $100mm in loans. Garrett holds an MBA from Texas A&M.',
  },
  {
    name: 'Sergey Maksimuk',
    role: 'Lead Engineer',
    image: '/img/team/sergey.jpg',
    description:
      'Sergey is a senior full stack engineer with a long history of working on world-class platforms. He prides himself on building stable products with clean code and elegant user experiences. His specialities are Node and React, but has experience with many tech stacks.',
  },
  {
    name: 'Chris Jaffe',
    role: 'Senior VP Capital Markets',
    image: '/img/team/jaffe.jpg',
    description:
      "Chris has 8+ years of CRE experience, most recently with JLL's Capital Markets team, where he facilitated over $1 billion in closes. Prior to JLL, he was a strategic consultant to institutional clients at Cushman & Wakefield. Chris holds a Master's in Real Estate Finance from Georgetown and a Bachelor's in Economics from Vanderbilt.",
  },
  {
    name: 'Jake Ratzker',
    role: 'VP Capital Markets',
    image: '/img/team/ratzker.jpg',
    description:
      'Jake is a CRE capital markets advisor with 6+ years of experience. Jake previously worked for Meridian and has a strong track record of success closing complex deals. Jake has a degree in accounting from Yeshiva University.',
  },
  {
    name: 'Chris Ford',
    role: 'VP Capital Markets',
    image: '/img/team/ford.jpg',
    description:
      'Chris has 6+ years of CRE experience in acquisitions, asset management, and investment sales. He previously worked for a hospitality-focused private equity firm in Atlanta and was involved in $200M+ in transactions. He holds a Master of Science in Commercial Real Estate degree from Georgia State University.',
  },
  {
    name: 'Jamie Talbot',
    role: 'CTO',
    image: '/img/team/talbot.jpg',
    description:
      "Jamie is a software engineer and executive with nearly 20 years in the tech industry. A veteran leader at both startups and established companies including StumbleUpon, Medium, Mailchimp, and Axios, Jamie is focused on helping build WelcomeLend's market-leading technology platform.",
  },
  {
    name: 'Rhett Saltiel',
    role: 'VP Capital Markets',
    image: '/img/team/saltiel.jpg',
    description:
      'Rhett is a seasoned capital markets expert focused on debt and equity with > $1B in CRE transactions under his belt. He previously spent 5 years at Walker & Dunlop working with institutional and middle market clients. Rhett is a graduate of Penn State University with a degree in accounting.',
  },
  {
    name: 'Ryan Fahy',
    role: 'SVP Capital Markets',
    image: '/img/team/fahy.jpg',
    description:
      'Ryan has 8+ years of industry experience, most recently serving as Director of Capital Markets at Greystone, where his team placed over $750mm annually. Prior to Greystone, Ryan spent 3+ years at Walker Dunlop where his team underwrote and placed over $5B in debt and equity. Ryan is a proud UCLA graduate.',
  },
  {
    name: 'Henry Sisson',
    role: 'SVP Capital Markets',
    image: '/img/team/sisson.jpg',
    description:
      'Henry has 8+ years of CRE experience, most recently as an Investment Associate at Redline Property Partners. Prior to Redline, Henry worked at HFF (now JLL) on the debt and equity team where he managed over $2.2 billion in institutional transactions. Henry holds a Business Administration Degree from the University of North Carolina at Chapel Hill.',
  },
  {
    name: 'Andrew Mitro',
    role: 'VP, Capital Markets',
    image: '/img/team/mitro.jpg',
    description:
      'Andrew has 10+ years of experience focused on debt and equity advisory in Colorado and the Mountain West. He was previously VP of Real Estate at RealtyMogul where he originated over $350M in JV and LP equity. Prior to RealtyMogul, Andrew underwrote $1B+ in CRE transactions at Wells Fargo. Andrew holds a BS in Finance from the University of Arizona and an MRED from University of Denver.',
  },
  {
    name: 'Brett Grubbs',
    role: 'VP, Capital Markets',
    image: '/img/team/grubbs.jpg',
    description:
      'Brett has 8+ years of CRE financing experience sourcing debt and equity for middle market sponsors and developers across the southeast and midwest. Brett has closed over $600mm in transactions. Prior to joining WelcomeLend, Brett was Director and originator at Greystone. He studied Finance at The University of North Carolina.',
  },
  {
    name: 'Will Clifton',
    role: 'VP, Capital Markets',
    image: '/img/team/clifton.jpg',
    description:
      'Will has 6+ years of CRE experience, most recently serving as a Vice President at Berkadia, where he facilitated over $2B in transactions. Prior to Berkadia, he worked at Northmarq focusing on the origination and structuring of multifamily debt. Will holds a B.B.A in Finance from the University of Georgia.',
  },
  {
    name: 'Casey Krebs',
    role: 'Head of Revenue Operations',
    image: '/img/team/krebs.jpg',
    description:
      'Casey has 6+ years of SaaS operations experience working at Slack and Apollo.io and 11+ years of operations experience at former asset manager OppenheimerFunds (now Invesco). Casey is focused on driving strategic growth through operational excellence, building data-driven solutions, and streamlining processes to enhance efficiency.',
  },
  {
    name: 'Mike Meisner',
    role: 'VP, Capital Markets',
    image: '/img/team/meisner.jpg',
    description:
      'Mike is a seasoned capital markets professional, bringing over 5 years of diverse experience most recently from JLL and Argentic. Mike has been involved in >$750M in transactions across all asset classes and markets throughout the country.  Mike holds a Master’s in Real Estate Finance from NYU and a Bachelor’s degree from the University of Delaware.',
  },
  {
    name: 'Conor McCarthy',
    role: 'VP, Capital Markets',
    image: '/img/team/mccarthy.jpg',
    description:
      'Conor has 7+ years of CRE experience, most recently with Berkadia’s Capital Markets team, where he facilitated over $2 billion in closings across multi-family, student housing, and industrial asset classes nationwide. Conor holds a Bachelor’s degree in Economics from Villanova University.',
  },
];
